export interface RentalCompany {
    accountId: string;
    contractType: ContractType;
    isShowcase: boolean;
}

export interface RentalCompanyWithName extends RentalCompany {
    name: string | undefined;
}

export type ContractType = 'ACCOUNT_WIDE' | 'ON_DEMAND' | 'INACTIVE';

export interface RenterPartnerCompany {
    accountId: string;
    name: string;
    creationFlow: CreationFlow;
}

export const CreationFlows = {
    INVITATION_FLOW: 'INVITATION_FLOW',
    ACCOUNT_ID_FLOW: 'ACCOUNT_ID_FLOW',
} as const;

export type CreationFlow = (typeof CreationFlows)[keyof typeof CreationFlows];
